<!-- Ported from the Polaris kit: src/components/ui/empty/Empty.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <div
    data-slot="empty"
    :class="
      cn(
        'flex min-w-0 flex-1 flex-col items-center justify-center gap-6 text-balance rounded-polaris-lg border-dashed p-6 text-center md:p-12',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
